<template>
  <div></div>
</template>
<script>
import { errorReport } from '@/utils/index.js'

export default {
  props: {
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  watch: {
    payLoad: {
      handler(newVal) {
        if (newVal) {
          this.doRedirect(newVal)
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * 对点击的响应
     * @param {Object} props 点击事件对应的图片组件信息
     */
    async doRedirect(props) {
      try {
        const platform = await this.getEnv()
        let link = ''
        if (platform === 1 && props.mpLink && this.tjChannelId === 'tujia') {
          // eslint-disable-next-line
          link = props.mpLink
        } else if (platform === 2 && props.appLink) {
          link = props.appLink
        } else if (props.activeLink) {
          link = props.activeLink
        }
        // 这个埋点方案不是很好。想想以后改进一下。其他地方同。
        if (window._vds && window._vds.track) {
          window._vds.track(`${this.$root.isMobile ? 'H5' : 'PC'}_cityname_cms`, {
            [`${this.$root.isMobile ? 'H5' : 'PC'}_cityname_cms_bian`]: link,
            'activityid_cms': this.$root.promotionId
          })
        }

        if (platform === 1 && props.mpLink && this.tjChannelId === 'tujia') {
          // eslint-disable-next-line
          wx.miniProgram&&wx.miniProgram.navigateTo({url: props.mpLink})
        } else if (platform === 2 && props.appLink) {
          window.location.href = props.appLink
        } else if (props.activeLink) {
          window.location.href = props.activeLink
        }
      } catch (e) {
        errorReport(e)
      }
    }
  }
}
</script>
